module.exports = __webpack_public_path__ + "static/media/0328_IMG_LE_PRIMEUR.faaf8e66.png";